module.exports = __webpack_public_path__ + "static/media/hut.9725dac6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/hut.svg
// module id = 284
// module chunks = 0